var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TotpInput',{attrs:{"label":_vm.uiLabel.totp.label,"hasAlreadySubmitted":_vm.hasAlreadySubmitted,"isLoading":_vm.isLoading,"token":_vm.token},on:{"interface":_vm.getChildInterface,"submit":_vm.submit},model:{value:(_vm.token),callback:function ($$v) {_vm.token=$$v},expression:"token"}})
}
var staticRenderFns = []

export { render, staticRenderFns }